import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import { useRef } from "react";

function SimpleTextFieldMUI(props) {
  const textField = useRef();

  return (
    <TextField
      ref={textField}
      hiddenLabel
      id={props.id}
      size="small"
      variant={props.variant || "filled"}
      type={props.type}
      value={props.value}
      onChange={props.onChange}
      onKeyDown={props.handleKeyPress}
      sx={{
        "& .css-mps6pm-MuiInputBase-input-MuiFilledInput-input": {
          padding: "1px 5px",

          fontSize: "0.85em",
          backgroundColor: props.backgroundColor
            ? props.backgroundColor
            : "white",
        },
        "& .css-6llvim": {
          padding: "1px 5px",
          fontSize: "0.85em",
          backgroundColor: props.backgroundColor
            ? props.backgroundColor
            : "white",
        },
        padding: "1px 5px",
        margin: "1px",
        width: props.width,
        height: "20px",

        textAlign: props.textAlign || "left",
      }}
    />
  );
}

export default SimpleTextFieldMUI;

SimpleTextFieldMUI.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.string,
  textAlign: PropTypes.string,
  handleKeyPress: PropTypes.func,
};
